import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const billCom = defineConnector({
  identifier: "billCom",
  name: "BILL Spend & Expense",
  tagLine: "Spend and expense management",
  logo,
  protocol: "http",
  tags: ["productivity", "data"],
  defaultUrlPattern: () => "https://gateway\\.(?:stage|prod)\\.bill\\.com/.*",
  auth: (app) =>
    headerAuth([
      { name: "apiToken", value: app.secret.apiToken },
      { name: "Accept", value: "application/json" },
    ]),
  steps: [
    {
      title: "Create a BILL Spend & Expense API token",
      items: [
        {
          kind: "markdown",
          content:
            "Create a Spend & Expense API token in BILL and copy it so 3B can attach it to outgoing API requests.",
        },
      ],
    },
    {
      title: "Enter your API token",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://gateway.prod.bill.com/connect/v3/spend/users/current",
      expectedStatus: [200, 403],
    }),
  },
});
